import { render, staticRenderFns } from "./ComulativeClientGrowth.vue?vue&type=template&id=cc7c3baa&scoped=true&"
import script from "./ComulativeClientGrowth.vue?vue&type=script&lang=js&"
export * from "./ComulativeClientGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7c3baa",
  null
  
)

export default component.exports